import { Instance, SnapshotOut, types } from 'mobx-state-tree';
import { withEnvironment } from 'src/models/extensions/withEnvironment';
import { withPagination } from 'src/models/extensions/withPagination';
import { withSetPropAction } from 'src/models/extensions/withSetPropAction';

import { Business, IBusiness } from '../business/Business';

/**
 * # BusinessStore
 *
 * BusinessStore을 설명하세요.
 */
export const BusinessStore = types
  .model('BusinessStore')
  .props({
    businesss: types.optional(types.array(Business), []),
  })
  .extend(withEnvironment)
  .extend(withPagination)
  .actions(withSetPropAction)
  .actions((self) => ({
    setBusinesss: (businesss: IBusiness[]) => {
      self.businesss.replace(businesss);
    },
  }));

// --------------------------------------------------------------------------
type TBusinessStore = Instance<typeof BusinessStore>;
type TBusinessStoreSnapshot = SnapshotOut<typeof BusinessStore>;

export interface IBusinessStore extends TBusinessStore {}
export type TBusinessStoreKeys = keyof TBusinessStoreSnapshot & string;
export interface IBusinessStoreSnapshot extends TBusinessStoreSnapshot {}
export const createBusinessStore = () => types.optional(BusinessStore, {} as TBusinessStore);
